import { YouTubeVideoData } from "../components/types";
import { translate, getKmsData, baseUrl } from "@kaltura/mediaspace-shared-utils";

/**
 * Fetches YouTube video information from the YouTube API
 * @param videoId The YouTube video ID
 * @returns Promise with the video data
 */
export async function fetchYouTubeVideoInfo(videoId: string): Promise<YouTubeVideoData> {
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    try {
        const url = `${baseUrl}/youtube/api/get-external-metadata?id=${videoId}&format=script`;
        const data = await getKmsData(url);
        const replaceNewlinesWithBr = (text: string): string => {
            return text.replace(/\n/g, "<br />");
        };
        //handle line breaks in the description
        if (data.result && data.result.description) {
            data.result.description = replaceNewlinesWithBr(data.result.description);
        }
        return {
            id: videoId,
            title: data.result.title,
            description: data.result.description,
            thumbnailUrl: thumbnailUrl,
            tags: data.result.tags || [],
            url: "",
        };
    }
    catch (error) {
        console.error("Error fetching YouTube video data, using default data. Error description:", error);

        // Fallback to a default response if the API call fails
        return {
            id: videoId,
            title: translate("YouTube Video %1", [videoId]),
            description: translate("No description available"),
            thumbnailUrl: thumbnailUrl,
            tags: [],
            url: "",
        };
    }
}
